var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9790_19131)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74715 13.0426C4.0941 11.974 3 10.1148 3 8C3 4.68629 5.68629 2 9 2C11.7958 2 14.1449 3.91216 14.811 6.5H17.25C19.3211 6.5 21 8.17893 21 10.25C21 12.3211 19.3211 14 17.25 14H8.25C7.28818 14 6.41093 13.6379 5.74715 13.0426Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03175 19.4923H10.9882V21.5C10.9882 21.7761 11.2121 22 11.4882 22H12.5115C12.7877 22 13.0115 21.7761 13.0115 21.5V19.4923H14.968C15.2441 19.4923 15.468 19.2685 15.468 18.9923C15.468 18.874 15.426 18.7595 15.3496 18.6692L12.3815 15.1636C12.203 14.9528 11.8875 14.9266 11.6768 15.1051C11.6557 15.1229 11.6361 15.1425 11.6183 15.1636L8.65015 18.6692C8.47172 18.88 8.49791 19.1955 8.70866 19.3739C8.79896 19.4504 8.91344 19.4923 9.03175 19.4923Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9790_19131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudVault);
export default __webpack_public_path__ + "static/media/cloudVault.8bfbabd3ce2bd8fcabfbd7db7866db7a.svg";
export { ForwardRef as ReactComponent };